import autosaveService from '../common/services/AutosaveService';



$(document).on('turbo:load', () => {
    $('a.add-interest').on('ajax:send', () => {
    });
    $('a.add-interest').on('ajax:complete', () => {
    });
});